export function Logo({
  color = 'currentColor',
  width = '100%',
  height = 'auto',
  noText = false,
}: {
  color?: string;
  width?: string;
  height?: string | number;
  noText?: boolean;
}) {
  const viewBox = noText ? '0 0 190 225' : '0 0 740 225';
  const style = { width, height };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox={viewBox}
      style={style}
    >
      <g>
        <path
          fill={color}
          d="M122.853,94.473c-1.474,0.168-2.934-0.316-4.083-1.272L54.01,39.249c-4.29-3.575-10.65-2.993-14.22,1.292 s-2.993,10.65,1.292,14.22l64.756,53.952c5.301,4.428,12.021,6.489,18.85,5.877c6.859-0.621,13.067-3.885,17.475-9.171 c4.413-5.296,6.499-11.992,5.873-18.85c-0.621-6.864-3.885-13.071-9.176-17.475L74.024,15.073 C56.505,0.468,30.347,2.84,15.742,20.374C1.132,37.903,3.514,64.05,21.043,78.655l98.793,82.324 c4.556,3.797,7.362,9.142,7.899,15.049c0.537,5.907-1.257,11.666-5.059,16.232c-3.792,4.556-9.137,7.357-15.049,7.899 c-5.922,0.503-11.671-1.272-16.227-5.059l-68.838-57.365c-4.29-3.56-10.65-2.988-14.22,1.292c-3.57,4.29-2.993,10.66,1.292,14.23 l68.838,57.365c7.692,6.4,17.179,9.822,27.07,9.822c1.302,0,2.608-0.059,3.92-0.178c11.282-1.026,21.483-6.38,28.732-15.078 c7.253-8.708,10.685-19.713,9.654-30.995c-1.026-11.282-6.38-21.488-15.083-28.737L33.971,63.143 c-8.974-7.48-10.192-20.867-2.717-29.841c3.624-4.349,8.723-7.026,14.358-7.539c5.67-0.488,11.139,1.203,15.483,4.822 l64.835,54.026c1.149,0.957,1.854,2.298,1.992,3.787c0.133,1.489-0.316,2.939-1.272,4.083 C125.689,93.635,124.342,94.345,122.853,94.473z"
        />
        {noText ? null : (
          <>
            <path
              fill={color}
              d="M233.789,122.763c-13.517-3.511-19.135-5.09-19.135-11.41c0-5.092,4.214-8.251,12.113-8.251 c8.777,0,14.044,3.862,14.044,12.991h23.523c0-19.837-14.044-30.194-37.391-30.194c-22.119,0-36.865,11.41-36.865,27.385 c0,20.714,15.974,24.225,30.896,28.087c13.868,3.687,20.539,5.267,20.539,12.991c0,5.267-4.389,8.601-12.99,8.601 c-8.799,0-14.059-3.802-15.325-10.614c-0.355-1.911-1.786-3.428-3.73-3.428h-17.498c-2.168,0-4.018,1.875-3.809,4.032 c1.819,18.829,16.679,27.741,39.836,27.741c24.225,0,39.322-11.235,39.322-27.911C267.318,131.013,249.763,126.976,233.789,122.763 z"
            />
            <path
              fill={color}
              d="M356.611,115.565c-5.617-18.081-20.714-29.666-41.253-29.666c-27.911,0-44.237,20.362-44.237,46.694 c0,28.439,16.326,48.1,44.413,48.1c21.053,0,35.595-10.668,41.041-24.496c1.005-2.552-0.71-5.347-3.453-5.347h-17.195 c-1.68,0-2.985,1.174-3.595,2.739c-2.244,5.755-8.264,9.724-16.798,9.724c-10.533,0-19.486-6.495-20.188-24.927h64.074 C359.42,128.556,358.542,121.71,356.611,115.565z M295.872,122.939c1.93-13.517,9.479-19.662,19.485-19.662 c9.831,0,17.906,6.145,19.486,19.662H295.872z"
            />
            <path
              fill={color}
              d="M409.738,104.857c9.48,0,15.799,6.496,16.677,17.028h25.63c-1.931-20.889-18.081-35.986-42.131-35.986 c-27.209,0-44.94,18.608-44.94,47.397s17.73,47.397,44.94,47.397c22.488,0,38.069-13.199,41.577-33.428 c0.391-2.253-1.488-4.315-3.775-4.315h-18.16c-1.895,0-3.377,1.456-3.691,3.326c-1.617,9.622-7.591,15.458-16.127,15.458 c-11.937,0-19.134-10.883-19.134-28.438C390.604,115.741,397.802,104.857,409.738,104.857z"
            />
            <path
              fill={color}
              d="M491.964,65.535h-24.576v23.171h-14.395v18.257h14.395v67.158c0,2.078,1.684,3.762,3.762,3.762h17.053 c2.077,0,3.762-1.684,3.762-3.762v-67.158h17.028V88.707h-17.028V65.535z"
            />
            <path
              fill={color}
              d="M532.685,51.31h-5.446c-6.304,0-11.414,5.11-11.414,11.414v1.407c0,6.304,5.11,11.414,11.414,11.414h5.446 c6.304,0,11.414-5.11,11.414-11.414v-1.407C544.099,56.421,538.989,51.31,532.685,51.31z"
            />
            <path
              fill={color}
              d="M517.674,174.122c0,2.078,1.684,3.762,3.762,3.762h17.052c2.077,0,3.762-1.684,3.762-3.762V88.707h-24.576V174.122z"
            />
            <path
              fill={color}
              d="M596.381,85.899c-27.911,0-45.642,18.431-45.642,47.397c0,28.965,17.73,47.397,45.642,47.397s45.642-18.433,45.642-47.397 C642.023,104.33,624.293,85.899,596.381,85.899z M596.381,161.734c-12.113,0-19.836-11.06-19.836-28.438 c0-17.379,7.724-28.439,19.836-28.439c12.113,0,19.836,11.06,19.836,28.439C616.218,150.674,608.494,161.734,596.381,161.734z"
            />
            <path
              fill={color}
              d="M700.315,86.212c-11.411,0-20.364,5.83-26.157,13.729h-0.351V88.707h-22.996v85.416c0,2.078,1.684,3.762,3.762,3.762 h17.053c2.078,0,3.762-1.684,3.762-3.762v-43.987c0-16.15,7.373-24.225,17.554-24.225c9.655,0,15.623,6.143,15.623,19.661v48.551 c0,2.078,1.684,3.762,3.762,3.762h17.053c2.078,0,3.762-1.684,3.762-3.762v-51.008C733.141,98.888,720.327,86.212,700.315,86.212z"
            />
          </>
        )}
      </g>
    </svg>
  );
}
